import _get from 'lodash/get';
import _castArray from 'lodash/castArray';

import { Base } from '@/models';
import { toCamelCase } from '@/utilities';

export class User extends Base {

  public id: string;
  public name: string;
  public email: string;
	public color: string;
  public branchlist: string[];

  /**
   * Constructor initialises the variables from the class User
   * @param data - the data to construct a type with all properties of <User>
   */
  public constructor(data?: Partial<User>) {
    super(data);
    data = toCamelCase(data);

    this.id = _get(data, 'id', '');
    this.name = _get(data, 'name', '');
    this.email = _get(data, 'email', '');
		this.color = _get(data, 'color', '');
    this.branchlist = _castArray(_get(data, 'branchlist', []));
  }

  /**
   * Create a JSON representation of this object and it's descedents.
   *
   * @return {Object}
   */
  public toJSON() {
    let json = super.toJSON();
    if (json.id) {
      json._id = json.id;
      //delete json.id;
    }
    return json;
  }

  /**
   * Convert class instance back into a plain old JSON object
   * and recursively remove all uuids we've add for Vue.
   *
   * @return {Object}
   */
  public toObject() {
    return new User(super.toObject());
  }

}
